import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { PrimaryButton } from '@/components/PrimaryButton';
import type { ConditionDifference } from '@/features/operations/condition';

/**
 * Saving something that contradicts the applicant is confirmed, not silent.
 *
 * The employee sees the two sides of every value that differs before it is written. What
 * agrees is left out on purpose: the point of the step is to make the disagreements
 * deliberate, and listing everything would bury them.
 */
export function ConditionConfirmDialog({
  differences,
  isSaving,
  onCancel,
  onConfirm,
}: {
  differences: ConditionDifference[] | null;
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={Boolean(differences)} onClose={onCancel}>
      <DialogTitle>Hay datos que no coinciden con lo declarado</DialogTitle>
      <DialogContent>
        <Stack spacing={1} sx={{ pt: 1 }}>
          {(differences || []).map((row) => (
            <Box key={row.fieldId}>
              <Typography variant="subtitle2">{row.fieldLabel}</Typography>
              <Typography variant="body2" color="text.secondary">
                Declarado: {row.declaredLabel ?? '—'}
              </Typography>
              <Typography variant="body2">Observado: {row.observedLabel ?? '—'}</Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onCancel} disabled={isSaving}>
          Volver a revisar
        </Button>
        <PrimaryButton onClick={onConfirm} disabled={isSaving}>
          {isSaving ? 'Guardando...' : 'Confirmar y guardar'}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
